export const BLOG_INDEX_PATH = "/blogs";
export const BLOG_POST_PATH_PREFIX = "/blog";

const POST_SLUG_OVERRIDES = {
  "why-i-built-stockeeper-and-the-real-problems-it-solves":
    "why-i-built-stockeeper",
};

const removeDiacritics = (value) =>
  value.normalize("NFKD").replace(/[\u0300-\u036f]/g, "");

export function slugifyTitle(value) {
  const slug = removeDiacritics(String(value || ""))
    .trim()
    .replace(/\.(md|mdx)$/i, "")
    .replace(/['’]/g, "")
    .replace(/&/g, " and ")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-+|-+$/g, "");

  return POST_SLUG_OVERRIDES[slug] || slug;
}

export function getPostSlugAliases(post = {}) {
  return [
    post.frontMatterSlug,
    post.metadata?.slug,
    post.slug,
    post.title,
    post.markdownTitle,
    getFilenameFromPath(post.githubPath || post.path || post.name),
  ]
    .map(slugifyTitle)
    .filter(Boolean);
}

export function getFilenameFromPath(path = "") {
  return String(path).split(/[?#]/)[0].split("/").filter(Boolean).pop() || "";
}

export function getPostSlug(post = {}) {
  return getPostSlugAliases(post)[0] || "";
}

export function getPostUrl(post = {}) {
  const slug = getPostSlug(post);
  return slug ? `${BLOG_POST_PATH_PREFIX}/${slug}` : BLOG_INDEX_PATH;
}

export function normalizeInternalPath(path = "") {
  const rawPath = String(path || "").trim();
  let decodedPath = rawPath;

  try {
    decodedPath = decodeURIComponent(rawPath);
  } catch {
    decodedPath = rawPath;
  }

  return decodedPath
    .split(/[?#]/)[0]
    .split("/")
    .filter((part) => part && part !== ".")
    .reduce((parts, part) => {
      if (part === "..") {
        parts.pop();
      } else {
        parts.push(part);
      }

      return parts;
    }, [])
    .join("/")
    .toLowerCase();
}

export function buildPostIndex(posts = []) {
  const bySlug = {};
  const byInternalPath = {};
  const slugCounts = {};

  const indexedPosts = posts.map((post) => {
    const baseSlug = getPostSlug(post) || "post";
    slugCounts[baseSlug] = (slugCounts[baseSlug] || 0) + 1;
    const slug =
      slugCounts[baseSlug] === 1 ? baseSlug : `${baseSlug}-${slugCounts[baseSlug]}`;
    return { ...post, slug };
  });

  indexedPosts.forEach((post) => {
    getPostSlugAliases(post).forEach((alias) => {
      if (!bySlug[alias]) {
        bySlug[alias] = post;
      }
    });
    bySlug[post.slug] = post;

    [post.githubPath, post.path, post.internalPath].filter(Boolean).forEach((path) => {
      byInternalPath[normalizeInternalPath(path)] = post;
    });
  });

  return {
    posts: indexedPosts,
    bySlug,
    byInternalPath,
  };
}
